'use strict';

angular.module('TurneroApp').component('coMailNotificaciones', {
	bindings: {
		idAgenda: '<',
		turnos: '<',
	},
	controller: [
		 'turnosService',
		 'utilsService',
		 'TurneroAppConstant',
		 '$mdDialog',
		 function (turnosService, utilsService, TurneroAppConstant, $mdDialog) {
		 	var ctrl = this;
		 	ctrl.Notificacion = {};
		 	ctrl.error = {};

		 	ctrl.limpiarVariables = function () {
		 		ctrl.error = {};
		 	};

		 	ctrl.$onChanges = function () {
		 		if (ctrl.idAgenda && ctrl.turnos) {
		 			turnosService.Traer_Notificaciones_Agenda_Combo({ 'Id_Agenda': ctrl.idAgenda, 'Id_Estado_Turno': ctrl.validarEstadoTurnos(ctrl.turnos) }).$promise.then(
						 function (resultado) {
						 	ctrl.Notificaciones_Agenda = resultado.Data;
						 }).catch(function (error) {
						 	utilsService.errores(error);

						 });
		 		}
		 	}
		 	ctrl.validarEstadoTurnos = function (turnos) {
		 		if (turnos.length > 1) {
		 			var Estado = turnos[0].Id_Estado;
		 			for (var i = 0; i < turnos.length; i++) {
		 				if (turnos[i].Id_Estado != Estado) {
		 					return null;
		 				}
		 			}
		 			return Estado;
		 		} else {
		 			return turnos[0].Id_Estado;
		 		}
		 	}

		 	ctrl.enviarNotificacion = function () {



		 		ctrl.error.Id_Notificacion = !ctrl.Notificacion.Id_Notificacion;
		 		ctrl.error.Descripcion = ctrl.Notificacion.Id_Notificacion == 'personalizada' && !ctrl.Notificacion.Descripcion;
		 		ctrl.error.Asunto = ctrl.Notificacion.Id_Notificacion == 'personalizada' && !ctrl.Notificacion.Asunto;
		 		if (ctrl.error.Id_Notificacion || ctrl.error.Descripcion || ctrl.error.Asunto) return;
		 		var turnos = ''
		 		for (var i = 0; i < ctrl.turnos.length; i++) {
		 			turnos = turnos.length > 0 ? turnos + ',' + ctrl.turnos[i].Id_Turno.toString() : ctrl.turnos[i].Id_Turno.toString();
		 		}


		 		if (ctrl.Notificacion.Id_Notificacion == 'personalizada') {
		 			utilsService.swalNotification('Enviando notificacion', 'Se esta enviando el correo...', 'info')
		 			turnosService.Enviar_Mail_Personalizado({ 'Id_Turno': turnos, 'Mensaje': ctrl.Notificacion.Descripcion, 'Asunto': (ctrl.Notificacion.Asunto ? ctrl.Notificacion.Asunto : '') }).$promise.then(function () {
		 				swal.close();
		 				swal('Enviado con exito', 'Se envió con exito el mensaje personalizado.', 'success')
		 				ctrl.cerrarModal();
		 			}).catch(function (error) {
		 				utilsService.errores(error);
		 			})
		 		} else {
		 			utilsService.swalNotification('Enviando notificacion', 'Se esta enviando el correo...', 'info')
		 			turnosService.Enviar_Notificacion_Mail({ 'Id_Turno': turnos, 'Id_Notificacion': ctrl.Notificacion.Id_Notificacion }).$promise.then(function () {
		 				swal.close();
		 				swal('Enviado con exito', 'Se envió con exito la notificación.', 'success')
		 				ctrl.cerrarModal();
		 			}).catch(function (error) {
		 				utilsService.errores(error);
		 			})
		 		}
		 	}

		 	ctrl.cerrarModal = function () {
		 		$mdDialog.destroy();
		 	}

		 }
	],
	template: require('./mailNotificaciones.html')
});


// WEBPACK FOOTER //
// ./app/shared/notificaciones/mailNotificacionesComponent.js